
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A list of pay types that specify the method and interval of a payment.`}</p>
    <p>{`These may be presented to a hirer for selection in a job posting flow.
A dropdown or radio group is recommended.`}</p>
    <p>{`This query accepts browser tokens that include the `}<inlineCode parentName="p">{`query:ontologies`}</inlineCode>{` scope.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;